import * as React from "react";
import { Grid, Button } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import { IManagementStore } from "@src/Stores/Management/types";
import { STGrid, STText, STFormWrapper } from "./styles";
import { Values } from "@src/Tools/Values";
import { Formik, FormikProps } from "formik";
import { STSelectLocation } from "../Authorization/SelectLocation/styles";
import { IValuesStore } from "@src/Stores/Values/types";
import { observable } from "mobx";
import { LocationShort } from "../../../Interfaces/Entity/Location";

interface IProps {
  routing?: RouterStore;
  management?: IManagementStore;
  values?: IValuesStore;
}

export interface IFormFields {
  location: string;
}

@inject("management", "routing", "values")
@observer
class Synchronization extends React.Component<IProps> {
  private isSynchronizationRunning: boolean = false;
  private isSynchronizationRequired: boolean = true;
  private syncLocation: LocationShort;
  @observable isLoading: boolean = true;

  checkIsSynchronizationRunning = async () => {
    this.isSynchronizationRunning = await this.props.management.checkIsSynchronizationRunning();
  };

  checkIsSynchronizationRequired = async () => {
    this.isSynchronizationRequired = await this.props.management.checkIsSynchronizationRequired();
  };

  async componentDidMount() {
    await this.checkIsSynchronizationRequired();
    await this.checkIsSynchronizationRunning();
    if (!this.isSynchronizationRequired && !this.isSynchronizationRunning){
        this.props.routing.history.push("/login");
    }

    if (this.isSynchronizationRunning) {
      this.handleSetInterval();
    } else {
      this.props.values.loginLocations = [];
      this.props.values.loginLocations.push(await this.props.management.getLocationForSync());

      if (this.props.values.loginLocations[0].id) {
          this.syncLocation = this.props.values.loginLocations[0];
      }
    }
    this.isLoading = false;
  }

   async handleRunSyncronization () {
    this.isSynchronizationRunning = true;
    await this.props.management.syncApplication(this.syncLocation.id);
    this.handleSetInterval();
    this.forceUpdate();
  };

  handleSetInterval = () => {
    const intervalId = setInterval(async () => {
      await this.checkIsSynchronizationRunning();
        if (!this.isSynchronizationRunning) {
          await this.checkIsSynchronizationRequired();
          if (!this.isSynchronizationRequired){
              this.props.routing.history.push("/login");
              clearInterval(intervalId);
          }
      }
    }, 3000);
  };

  render() {
    if (this.isLoading) {
      return null;
    }
    return (
      <STGrid container>
        <Grid item xs={12}>
          {this.isSynchronizationRunning ? (
            <STText>{Values.getLocalizationValue("initializingApplication")}</STText>
          ) : (
            <>
              <Formik
                onSubmit={(props) => this.handleRunSyncronization()}
                initialValues={{
                  location: this.syncLocation.id,
                }}
                render={(formikProps: FormikProps<IFormFields>) => (
                    <STFormWrapper onSubmit={formikProps.handleSubmit}>
                    <STText>{this.syncLocation.name}</STText>
                    <Button variant="contained" color="default" type="submit" style={{ marginTop: "24px" }}>
                      {Values.getLocalizationValue("startSynchronization")}
                    </Button>
                  </STFormWrapper>
                )}
              />
            </>
          )}
        </Grid>
      </STGrid>
    );
  }
}
export default Synchronization;
